import { render, staticRenderFns } from "./Hooks.vue?vue&type=template&id=ddbe29d0&scoped=true&"
import script from "./Hooks.vue?vue&type=script&lang=js&"
export * from "./Hooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbe29d0",
  null
  
)

export default component.exports